import Autosuggest from "react-autosuggest";
import BaseComponent from "../../../baseComponent.js";
import DatasetService from "../../../../core/services/datasetService.js";
import styles from "./create-dataset.scss";


export default class AutoSuggest extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = this.props.data;
    this.state.selected = false;
  }

  getSuggestionValue(suggestion) {
    return suggestion.name;
  }

  reset(){
    this.state.selected = false;
    this.state = this.props.data;
  }


  onDataProfileSearchValueChange(event, payload) {
      this.state.dataset.dataProfile = null;
      this.setState({
        dataProfileSearchValue: payload.newValue,
      });

    //this.state.dataProfileSearchValue = payload.newValue;
    this.state.reset = false;
    this.props.callback(this.state);
  }

  onSuggestionsUpdateRequested(payload) {
    let suggestions = [];
    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => {
      // TODO: change to other api call
      DatasetService.getAllDataProfiles((res) => {
        this.dataProfiles = res.data;

        for (let i = 0; i < this.dataProfiles.length; i++) {
          let profileName = this.dataProfiles[i].name.toLowerCase();
          let searchValue = payload.value.toLowerCase().trim();

          if (profileName.indexOf(searchValue) > -1) {
            suggestions.push(this.dataProfiles[i]);
          }
        }

        if(this.state.selected == false) {
          this.setState({
            suggestions: suggestions
          });
        }
        else{
          this.state.suggestions = suggestions;
        }
        this.state.selected = false;
      });
    }, 300);

  }

  selectedValue(){
    this.setState({selected: true});
    this.props.callback(this.state);
  }

  renderSuggestion(suggestion) {
    return (
      <div className={styles.dataProfile} onClick={this.selectedValue}>
        <span>{suggestion.name}</span>
        <i className="material-icons" onMouseDown={(e) => this.showDataProfileDetail(e, suggestion)}>info_outline</i>
      </div>
    );
  }

  showDataProfileDetail(event, dataProfile) {
    event.preventDefault();
    event.stopPropagation();
    this.setState({
      dataProfileDetail: dataProfile,
    });
    this.props.openProfileDetail(dataProfile);
  }

  handleDataProfileSelect(e, payload) {
    let dataset = this.state.dataset;
    dataset.dataProfile = payload.suggestion;
    this.state.selected = true;

    let suggestions = this.state.suggestions;

    for(let i = 0; i < suggestions.length; i++){
      if(!(suggestions[i].name.toUpperCase().indexOf(dataset.dataProfile.name.toUpperCase()) > -1)) {
        delete this.state.suggestions[i];
      }
    }

    this.setState({
      dataset: dataset
    });


    $(this.refs.dataProfile).find("input").removeClass("invalid");
  }

  shouldComponentUpdate(nextProps, nextState){
    if(nextProps.data.reset == true) {
      this.state.dataProfileSearchValue = "";
      this.setState(nextProps.data);
      return true;
    }


    this.state.selected = false;
      return true;


  }

  render() {
    let inputProps = {
      value: this.state.dataProfileSearchValue,
      onChange: (e, payload) => {
        this.onDataProfileSearchValueChange(e, payload)
      },
      onFocus: (e) => {
        $(e.target).parents(".autosuggest-wrapper").find("label").removeClass("has-value").addClass("active");
      },
      onBlur: (e, payload) => {
        if (e.target.value.length > 0) {
          $(e.target).parents(".autosuggest-wrapper").find("label").addClass("has-value");
        } else {
          $(e.target).parents(".autosuggest-wrapper").find("label").removeClass("active").removeClass("has-value");
        }

        if (payload.focusedSuggestion !== null) {
          this.handleDataProfileSelect(null, {suggestion: payload.focusedSuggestion});
        }
      }
    };

      return (
        <div id="AutoSuggest" className="autosuggest-wrapper" ref="dataProfile">
          <Autosuggest
            suggestions={this.state.suggestions}
            getSuggestionValue={suggestion => this.getSuggestionValue(suggestion)}
            onSuggestionsUpdateRequested={payload => this.onSuggestionsUpdateRequested(payload)}
            renderSuggestion={suggestion => this.renderSuggestion(suggestion)}
            onSuggestionSelected={(e, payload) => this.handleDataProfileSelect(e, payload)}
            inputProps={inputProps}/>
          <label>Data Profile</label>
        </div>
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/data-bank/create/dataset/autoSuggestWrapper.jsx